import * as svg from "../../../assets/pointer-down.svg";

import {iconBuilder} from "./iconBuilder";

export const PointerDownIcon = iconBuilder(svg, "PointerDownIcon", "0 0 24 24");
